import {useQuery} from "react-query";
import {useSelector} from "react-redux";
import * as CustomerService from ".././services/customer-service";

export default function useEntrepreneurs() {
  const authState = useSelector((state) => state.auth);
  return useQuery("entrepreneurs", () => CustomerService.fetchEntrepreneurs(authState.roles), {
    initialData: [],
    initialStale: true,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });
}
